const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconLupa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.05 24.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.55,24.05a.47.47,0,0,1-.35-.15l-5-5a.5.5,0,0,1,.71-.71l5,5a.48.48,0,0,1,0,.7A.47.47,0,0,1,23.55,24.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.06,22.13A11.07,11.07,0,1,1,22.13,11.07,11.07,11.07,0,0,1,11.06,22.13ZM11.06,1A10.07,10.07,0,1,0,21.13,11.07,10.08,10.08,0,0,0,11.06,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLupa);
export default __webpack_public_path__ + "static/media/icon_lupa.b4ddc245eec7e114ea463e3784de502d.svg";
export { ForwardRef as ReactComponent };